export default __webpack_public_path__ + "static/media/Create_Schedule.3920c0a4.svg";